<template>
    <div>
        <slot :form="form" :state="state" :contacto="contacto"></slot>
    </div>
</template>

<script>
import Axios from 'axios';

export default {
    data() { return {
        form: {},
        state: 1,
        contacto: {},
    }},
    mounted() {
        const vm = this;
        const formContacto = $('#formContacto');

        formContacto.submit(function(event) {
            event.preventDefault();          
            vm.nuevoContacto();
        });
    },
    methods: {
        nuevoContacto() {
            axios.post('contacto/nuevoContacto', this.form).then(res => {
                if(!res.data.error) {
                    this.contacto = res.data.contacto;
                    this.state = 2;
                }
            }).catch(e => {
                console.log(e);
            });
        }
    }
}
</script>